<script>
  import { onDestroy, onMount } from "svelte";
  import Progressbar from "./progressbar.svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../lib/mountFederatedSvelteComponent";

  let el1;
  let opportunityTeamsInstance = null;

  let total = 0;
  let completed = 0;
  let showProgressBar = false;

  const mountOpportunityTeams = async () => {
    const { default: OpportunityTeams } = await import(
      "App/alaceOpportunityTeams"
    );

    if (el1) {
      opportunityTeamsInstance = mountFederatedSvelteComponent(
        opportunityTeamsInstance,
        OpportunityTeams,
        {
          target: el1,
          props: {
          translation: {
            firstName: "First Name",
            lastName: "Last Name",
            email: "Email",
            phone: "Phone",
            title: "Title",
          },
          schema: {
            actions: {
              edit: { removable: true, "with-confirmation": true },
            },
            "field-properties": {
              "auto-generated-fields": [
                "id",
                "opportunityId",
                "firstName",
                "lastName",
                "email",
                "phone",
                "title",
              ],
              "field-order": ["firstName", "lastName", "email", "phone", "title"],
            },
          },
          },
        }
      );
    }
  };

  onMount(() => {
    void mountOpportunityTeams();
  });

  onDestroy(() => {
    opportunityTeamsInstance = destroySvelteComponentInstance(opportunityTeamsInstance);
  });
</script>

{#if showProgressBar}
  <Progressbar {completed} {total} />
{/if}

<div bind:this={el1} />
